<script>
	// Componentes Svelte
	import { Router, Link, link , Route } from "svelte-routing";
	import PageHeader from './../components/PageHeader.svelte';

	import {
		textSite
	} from '../store.js';

</script>

<PageHeader title="Oops, página não encontrada"></PageHeader>
<div class="container">
	<p>O endereço abaixo não existe na {$textSite}</p>
	<b>{document.location.href}</b>
</div>